import { TEMP_ROUTE } from '../constants';

// Mirrors the REMOVE_ROUTE document exactly so the board paints before the
// server round trip; every entity must be fragment-complete or the watched
// planning query goes partial and the optimistic paint silently no-ops.
export const buildOptimisticRemoveResponse = ({ actionableRoute, routeUpdate, deliveries, orderUpdates }) => ({
    delete_order_route_mappings: {
        __typename: 'order_route_mappings_mutation_response',
        affected_rows: (actionableRoute.orders || []).length,
        returning: (actionableRoute.orders || []).map((mapping) => ({
            __typename: 'order_route_mappings',
            ...mapping,
        })),
    },
    insert_routes_one: {
        ...TEMP_ROUTE,
        ...actionableRoute,
        ...routeUpdate,
        __typename: 'routes',
    },
    insert_order_wh_events: {
        __typename: 'order_wh_events_mutation_response',
        affected_rows: 0,
        returning: [],
    },
    update_orders_many: [
        {
            __typename: 'orders_mutation_response',
            affected_rows: deliveries.length,
            returning: deliveries.map((order, i) => ({
                ...order,
                ...orderUpdates[i]._set,
                __typename: 'orders',
            })),
        },
    ],
    delete_stops: {
        __typename: 'stops_mutation_response',
        returning: (actionableRoute.stopsByRouteId || []).map((s) => ({
            __typename: 'stops',
            stop_id: s.stop_id,
        })),
    },
});

// Mirrors the RESCHEDULE_ROUTE document exactly so the board repaints
// (route + stops cleared) at click time instead of after the response,
// matching every entity the mutation touches.
export const buildOptimisticRescheduleResponse = ({ route, deliveryDateISO, pickups, dropoffs }) => ({
    update_routes_by_pk: {
        __typename: 'routes',
        route_id: route.route_id,
        route_number: route.route_number,
        route_color: null,
        start_time: null,
        need_to_optimize: true,
        scheduled_delivery: deliveryDateISO,
    },
    update_stops: {
        __typename: 'stops_mutation_response',
        returning: (route.stopsByRouteId || []).map((s) => ({
            __typename: 'stops',
            stop_id: s.stop_id,
            del_window_start: null,
            del_window_end: null,
            original_del_window_start: null,
            original_del_window_end: null,
            stop_start_time: null,
            stop_end_time: null,
            driving_time: null,
            driving_distance: null,
        })),
    },
    pickups: {
        __typename: 'orders_mutation_response',
        returning: pickups.map((mapping) => ({
            __typename: 'orders',
            order_id: mapping.order_id,
            order_number: mapping.order?.order_number,
            pickup_date: deliveryDateISO,
        })),
    },
    dropoffs: {
        __typename: 'orders_mutation_response',
        returning: dropoffs.map((mapping) => ({
            __typename: 'orders',
            order_id: mapping.order_id,
            order_number: mapping.order?.order_number,
            delivery_date: deliveryDateISO,
            del_window_start: null,
            del_window_end: null,
            original_del_window_start: null,
            original_del_window_end: null,
            delivery_time_confirmed: null,
            confirmation_source: null,
        })),
    },
});
